import { render } from "./LangDropdown.vue?vue&type=template&id=65955619"
import script from "./LangDropdown.vue?vue&type=script&lang=js"
export * from "./LangDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__